import { AxiosRequestConfig } from "axios";

import { Api } from "./generated";
export { queryClient } from "./queryClient";

export const baseURL = window.BACKEND_URL || "https://legalgw.test.almaty-parking.kz";

const config: AxiosRequestConfig = { baseURL };

const apiInstance = new Api(config);

// Сдвиг от UTC в минутах (как в mobile-gateway): для Алматы = 300.
apiInstance.interceptors.request.use((req) => {
  req.headers["X-Client-TimeZone"] = String(-new Date().getTimezoneOffset());
  return req;
});

export const requests = apiInstance.v1;
export const interceptors = apiInstance.interceptors;
export const axiosInstance = apiInstance.instance;
